import { useDispatch, useSelector } from 'react-redux';

import {
  getModuleDetails,
  setModuleDetailsAction,
  clearModuleDetailsAction,
  setModulesAction,
  clearModulesAction,
} from 'features/modules/redux/slice';

import { UseModulesState, ModulesDetailsApiResponse, ModulesApiResponse } from './types';

const useMenu = (): UseModulesState => {
  const dispatch = useDispatch();

  const { groups, modules, modulesInfo, moduleDetails } = useSelector(getModuleDetails);

  const setModuleDetails = (receivedModule: ModulesDetailsApiResponse) => {
    dispatch(setModuleDetailsAction(receivedModule));
  };

  const clearModuleDetails = () => {
    dispatch(clearModuleDetailsAction());
  };

  const setModules = (receivedModule: ModulesApiResponse) => {
    dispatch(setModulesAction(receivedModule));
  };

  const clearModules = () => {
    dispatch(clearModulesAction());
  };

  return {
    groups,
    modules,
    modulesInfo,
    setModules,
    clearModules,

    moduleDetails,
    setModuleDetails,
    clearModuleDetails,
  };
};

export default useMenu;
